import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Subscription, debounceTime, fromEvent, map } from 'rxjs';
@Component({
  selector: 'app-custom-text-field',
  templateUrl: './custom-text-field.component.html',
  styleUrls: ['./custom-text-field.component.less'],
})
export class CustomTextFieldComponent {
  subscriptions: Subscription[] = [];
  @Input() maxLength: number = 10000;
  @Input() fieldTitle?: string;
  @Input() required: boolean = false;
  @Input() placeholder: string = '';
  @Input() type: 'text' | 'email' | 'number' | 'password' | 'mobile' | 'alphaNumeric' | 'numberOnly' | 'registrationNumber' = 'text';
  @Input() value: any = '';
  @Input() validator?: Function;
  @Input() width: number = 100;
  @Input() widthUnit: 'px' | '%' | 'rem' | 'em' = 'px';
  @Input() height: number = 76;
  @Input() heightUnit: 'px' | '%' | 'rem' | 'em' = 'px';
  @Input() disabled: boolean = false;
  @Input() suffixIcon?: string;
  @Input() suffixText?: string;
  @Output() iconClicked = new EventEmitter();
  @Input() iconWidth: string = '16px';
  @Input() iconHeight: string = '16px';
  @Output() valueChange = new EventEmitter<string | number>();
  @Output() dropdownChange = new EventEmitter<string | number>();
  @Input() errorMessage?: string;
  @Input() charLimitError:string='';
  @Input() showError: boolean = false;
  @Input() disableInput: boolean = false;
  @Input() commaSeparator?: boolean = false;
  @Input() allowNegative?: boolean = true;
  @Input() includeErrorMsgPaddingFlag: boolean = false;
  @Input() tooltipDirection: 'bottom' | 'right' | 'left' | 'top' = 'right';
  @Input() toolTipMessage: string = '';
  @Input() tooltipWidth: number = 200;
  @Input() tooltipWidthUnit: 'px' | '%' | 'rem' | 'em' = 'px';
  @Input() tooltipHeight: number = 48;
  @Input() suffixWidth: number = 5;
  @Input() fieldColor: string = '#fafafa';
  @Input() isCentreAlign:boolean=false;
  @Input() selectDropdownConfig?: {
    selectedValue: any;
    width: number;
    placeholder: string;
    options: {
      key: string | number;
      value: string | number;
    }[];
    onChange?: Function;
  };
  @Input() highlightOnFocus: string = '';
  @Input() autofocusField: boolean = false;
  @Input() defaultFocus: boolean = false;
  @Input() focusBorder: string = '#dfe6ea';
  @Input() focusBorderToolTip:boolean=false;

  isInputValid: boolean = true;
  randomNumber: number = 12;
  @Input() readOnly: boolean = false;
  @Input() disableEdit: boolean = false;
  @Input() urlDropdownField: boolean = false;
  @Input() whiteSpacesNotAllowed: boolean = false;
  @Input() delay?: number = 0;
  @Input() escapeCharacters : any = [] ;
  @Input() restrictDecimal : boolean = false ;


  @Output() onBlur: EventEmitter<void> = new EventEmitter<void>();
  @Output() onEnter: EventEmitter<any> = new EventEmitter<any>();
  @Input() disableSuffixIcon:boolean = false;
  @Input() prefixText?:string;
  @Input() mobileMaxLength?:any;
  lastInputType: 'copy' | 'paste' | 'keydown' | 'selectall' | null = null;
  constructor(
    public elementRef: ElementRef
  ){}

  ngOnInit(): void {
    this.listenChanges();
    this.generateRandomNumber();
    if(this.type==='number' && this.commaSeparator){
      this.onUpdate(this.value);
    }
  }

  iconClick() {
    this.iconClicked.emit({});
  }
  formatValue(inputValue: string): string | undefined {
    if (
      this.type == 'number' &&
      this.commaSeparator &&
      inputValue?.length > 0
    ) {

      let integerPart = inputValue.replace(/,/g, '');

      let parts = integerPart.split('.');
      let formattedIntegerPart = parts[0];
      let decimalPart = parts.length > 1 ? parts[1] : '';

    formattedIntegerPart = formattedIntegerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    let formattedValue = formattedIntegerPart + (decimalPart ? '.' + decimalPart : '');

      return formattedValue;
      
    }
    return inputValue ?? '';
  }

  onCopy() {
    this.lastInputType = 'copy';
  }
  onKeyDown(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'a') {
      this.lastInputType = 'selectall';
    } else {
      this.lastInputType = 'keydown';
    }
  }
  onUpdate(event: string | number) {
    if (
      this.lastInputType === 'copy' ||
      this.lastInputType === 'selectall'
    ) {
      this.lastInputType = null;
      return;
    }
    this.value = event?.toString() || '';
    if (this.value.trim() === '') {
      this.value = '';
      const ele = this.inputFieldRef?.nativeElement;
      if (ele) ele.value = '';
      this.valueChange.emit(this.type=='number'? undefined:this.value);
      return;
    }
    if (this.type == 'number' && event?.toString()?.length > 0) {
      this.value = event.toString().replace(/[^-0-9.]/g, '');
      // Ensure there is only one '-' at the beginning (for negative numbers)
      if (this.value.startsWith('-') && this.allowNegative) {
        this.value = '-' + this.value.replace(/-/g, '');
      } else {
        this.value = this.value.replace(/-/g, '');
      }

      if (this.restrictDecimal) {
        this.value = this.value.split('.')[0];
      } else {
        this.value = this.value.replace(/(\..*)\./g, '$1');
      }

      // Ensure there is only one '.' in the number
      this.value = this.value.replace(/(\..*)\./g, '$1');
      if(!this.commaSeparator){
        const ele: any = this.inputFieldRef?.nativeElement;
        ele.value = this.value;
      } else {
        const startCursorPosition = this.inputFieldRef?.nativeElement?.selectionStart;

        const endCursorPosition = this.inputFieldRef?.nativeElement?.selectionEnd;

        if(endCursorPosition - startCursorPosition == 1){
          setTimeout(() => {
            this.inputFieldRef?.nativeElement?.setSelectionRange(endCursorPosition,endCursorPosition);
          }, 0);
        }
      }
    }
    if(this.type == 'text' && this.whiteSpacesNotAllowed) {
      this.value = this.value.replace(/\s/g , '');
      const ele: any = this.inputFieldRef?.nativeElement;
      ele.value = this.value;
    }
    if(this.escapeCharacters.length > 0) {
      this.escapeCharacters.forEach((char: string) => {
        this.value = this.value.replace(new RegExp(char, 'g'), '');
        const ele: any = this.inputFieldRef?.nativeElement;
        ele.value = this.value;
      });
    }
    this.valueChange.emit(this.value);
  }

  listenChanges() {
    const stream = fromEvent(this.elementRef.nativeElement, 'keyup')
      .pipe(
        map(() => this.value),
        debounceTime(this.delay?? 0),
        // distinctUntilChanged()
      )
      .subscribe((input) => {
        this.onUpdate(input);
      });
    this.subscriptions.push(stream);
  }

  // To handle comma seperator input without breaking other values

  // onUpdateCommaSeperatorValue(event: string | number) {
  //   this.value = event;
  //   this.valueChange.emit(event);
  // }
  changedDropdownValue($event: any) {
    this.dropdownChange.emit($event);
  }
  validateInput() {
    this.isInputValid = false;
    this.errorMessage = '';
    if (this.required && this.isValueFilled(this.value?.toString())) {
      this.errorMessage =
        (this.fieldTitle ? `"${this.fieldTitle}" ` : `This field `) +
        `is required.`;
    } else if (this.validator) {
      this.errorMessage = this.validator(this.value) ?? '';
    }
    if (
      this.errorMessage == null ||
      this.errorMessage == undefined ||
      this.errorMessage.length == 0
    ) {
      this.isInputValid = true;
    }
  }

  generateRandomNumber() {

    this.randomNumber = Math.floor(Math.random() * 100) + 1;
  }
  onlyNumber(event: KeyboardEvent) {
    // const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];

    // if (allowedKeys.includes(event.key)) {
    //   return;
    // }

    // if (!/\d/.test(event.key)) {
    //   event.preventDefault();
    // }
  }

  ngAfterViewInit() {
    this.elementRef.nativeElement.addEventListener('wheel', this.handleWheel, { passive: false });
    setTimeout(() => {
      if (this.autofocusField && this.inputFieldRef) {
        if (this.defaultFocus) {
          this.inputFieldRef.nativeElement.focus();
          this.focusBorder = this.highlightOnFocus;
        }
      }
    }, 500);
  }

  isValueFilled(value?: string) {
    return value == undefined || value == null || value.length == 0;
  }

  handleBlur() {
    this.onBlur.emit();
    this.resetFieldStyles();
  }

  resetFieldStyles() {
    this.focusBorder = '#dfe6ea';
  }

  setBorderhighlight() {
    if (this.autofocusField) {
      this.focusBorder = this.highlightOnFocus;
    }
  }

  @ViewChild('InputField') inputFieldRef: ElementRef | undefined;

  enterClicked(event: any) {
    this.onEnter.emit(event.target.value);
  }

  public get clientRect(): any {
    return this.inputFieldRef?.nativeElement?.getClientRects();
  }

  handleWheel = (event: WheelEvent) => {
    document.addEventListener('wheel', (event) => {
        const target = event?.target as HTMLElement;
        const inputField = document.getElementById('noscrol');
        if (event.deltaX !== 0 && target.id ===('noscrol_' + this.randomNumber)) {
          event.preventDefault();
        }

    },{ passive: false });
  }
  ngOnDestroy(): void {
    this.elementRef.nativeElement.removeEventListener('wheel', this.handleWheel);
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }

  validateInputType(event: any) {
    let inputValue = event.target.value;
    const inputElement = event.target;

    const start = inputElement.selectionStart;
    const end = inputElement.selectionEnd;

    if (this.type === 'mobile') {
      inputValue = inputValue.replace(/[^0-9]/g, '');
      inputValue = inputValue.replace(/^0+/, '');
      inputValue = inputValue.slice(0, this.mobileMaxLength);
    }
    if(this.type === 'alphaNumeric'){
      inputValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
    }
    if(this.type === 'numberOnly'){
      inputValue = inputValue.replace(/[^0-9]/g, '');
    }
    if (this.type === 'registrationNumber') {
      const inputElement = event.target;
      let rawValue = inputElement.value;
      const prevCursor = inputElement.selectionStart;
      let digitsOnly = rawValue.replace(/[^0-9]/g, '');
      digitsOnly = digitsOnly.slice(0, 12);
      let formatted = '';
      for (let i = 0; i < digitsOnly.length; i++) {
        formatted += digitsOnly[i];
        if ((i === 3 || i === 9) && i !== digitsOnly.length - 1) {
          formatted += '/';
        }
      }
      if (formatted.endsWith('/')) {
        formatted = formatted.slice(0, -1);
      }
      const diff = formatted.length - rawValue.length;
      const newCursorPos = Math.max(prevCursor + diff, 0);
      inputElement.value = formatted;
    
      setTimeout(() => {
        this.valueChange.emit(formatted);
        inputElement.setSelectionRange(newCursorPos, newCursorPos);
      }, 0);
    
      return;
    }
         
    if (inputElement.value !== inputValue) {
      inputElement.value = inputValue;
      setTimeout(() => {
        this.valueChange.emit(inputValue);
        const newPos = Math.min(inputValue.length, end);
        inputElement.setSelectionRange(newPos, newPos);
      }, 0);
    }
  }

  
  restrictInputNumberToLimit(event: KeyboardEvent){
    const inputElement = event.target as HTMLInputElement;
    if (this.maxLength !== 1000 && (this.type === 'number' || this.type === 'numberOnly') && inputElement.value.length === this.maxLength) {
      event.preventDefault();
    }
  }

}

